/**
 * Read:
 * - https://github.com/pmndrs/zustand/issues/882
 * - https://github.com/pmndrs/zustand/blob/main/docs/guides/updating-state.md
 */

import { AccountMeta } from '@diamond/shared/types';
import create from 'zustand';
// import createContext from 'zustand/context';
import { persist } from 'zustand/middleware';

export type SessionState = {
  userId: string;
  userName: string;
  userRole: string;
  access_token: string;
  refresh_token: string;
  user: Pick<AccountMeta, 'id' | 'email'> | null;
};

type ActionState = {
  setUserId: (userId: SessionState['userId']) => void;
  setUserName: (userId: SessionState['userName']) => void;
  setUserRole: (userId: SessionState['userRole']) => void;
  setAccessToken: (userId: SessionState['access_token']) => void;
  setRefreshToken: (refreshToken: SessionState['refresh_token']) => void;
  setUser: (user: SessionState['user']) => void;
  resetSession: () => void;
};

const defaultValues: SessionState = {
  userId: '',
  userName: '',
  userRole: '',
  access_token: '',
  refresh_token: '',
  user: null,
};

export const useAuthStore = create<SessionState & ActionState>()(
  persist(
    (set) => ({
      ...defaultValues,
      setUserId: (userId) => set(() => ({ userId: userId })),
      setUserName: (userName) => set(() => ({ userName: userName })),
      setUserRole: (userRole) => set(() => ({ userRole: userRole })),
      setAccessToken: (access_token) =>
        set(() => ({ access_token: access_token })),
      setRefreshToken: (refresh_token) =>
        set(() => ({ refresh_token: refresh_token })),
      setUser: (user) => set(() => ({ user: user })),
      resetSession: () => set(() => defaultValues),
    }),
    {
      name: 'session-store', // must be a unique name
      getStorage: () => localStorage, // sessionStorage or localStorage
    }
  )
);

// This will replace current AuthContext in the future
// export const AuthContext = createContext<typeof useAuthStore>();
